import { useState, useEffect } from "react";
import { Grid, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import classes from "./AccessModalContent.module.css";
import { useSelector, useDispatch } from "react-redux";
import { obtInfoManagementActions } from "Store/obtInfoManagement";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";

const AccessModalContent = (props) => {
  const details = useSelector((state) => state.obtInfoManagement);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setLoader(props.loading);
  }, [props.loading]);

  return (
    <>
      {loader ? (
        <div className={classes.loader}>
          <CircularProgress sx={{ color: "#A8A8A8" }} />
        </div>
      ) : null}
      <p className={classes.header}>
        Access
        <CloseIcon
          sx={{
            fontSize: "23px",
            marginLeft: "33rem",
            cursor: "pointer",
          }}
          onClick={props.onClose}
        ></CloseIcon>
      </p>
      <Grid container spacing={1}>
        <Grid className={classes.label} item xs={12}>
          <p>TTEC Access SLA (Bus. Days)</p>
        </Grid>
        <Grid
          item
          xs={8}
          sx={{
            marginBottom: "10px",
          }}
        >
          {" "}
          <TextField
            id="outlined-basic"
            variant="outlined"
            required
            multiline
            value={details.ttecAccessSLABusDays}
            placeholder="Add text"
            rows={1}
            className={classes.textfield}
            sx={{
              "& .MuiInputBase-input": {
                padding: "9.5px",
                color: "#3f5765",
              },
            }}
            onChange={(e) => {
              if (e.target.value === "" || /^[0-9\b]+$/.test(e.target.value)) {
                dispatch(
                  obtInfoManagementActions.setTtecAccessSLABusDays(
                    Number(e.target.value)
                  )
                );
              }
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.label}>
          <p>Client Access SLA (Bus. Days)</p>
        </Grid>
        <Grid
          item
          xs={8}
          sx={{
            marginBottom: "10px",
          }}
        >
          {" "}
          <TextField
            id="outlined-basic"
            variant="outlined"
            required
            className={classes.textfield}
            placeholder="Add text"
            multiline
            value={details.clientAccessSLABusDays}
            rows={1}
            sx={{
              "& .MuiInputBase-input": {
                padding: "9.5px",
                color: "#3f5765",
              },
            }}
            onChange={(e) => {
              if (e.target.value === "" || /^[0-9\b]+$/.test(e.target.value)) {
                dispatch(
                  obtInfoManagementActions.setClientAccessSLABusDays(
                    Number(e.target.value)
                  )
                );
              }
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.label}>
          <p>Client Access Request Type</p>
        </Grid>
        <Grid
          item
          xs={8}
          sx={{
            marginBottom: "10px",
          }}
        >
          {" "}
          <TextField
            type="text"
            id="outlined-basic"
            variant="outlined"
            required
            placeholder="Input"
            multiline
            value={details.clientAccessRequestType}
            className={classes.textfield}
            rows={1}
            inputProps={{ maxLength: 50 }}
            helperText={
              details.clientAccessRequestType?.length === 50
                ? "Reached the limit of 50 Characters"
                : ""
            }
            onChange={(e) => {
              dispatch(
                obtInfoManagementActions.setClientAccessRequestType(
                  e.target.value
                )
              );
            }}
            sx={{
              "& .MuiInputBase-input": {
                padding: "9.5px",
                color: "#3f5765",
              },
              "& .MuiFormHelperText-root": {
                color: "red",
              },
            }}
          />
        </Grid>
      </Grid>
      <div className={classes.buttonContainer}>
        <Button
          sx={{
            textTransform: "none",
            borderRadius: "7px",
            borderColor: "#1a8cff",
          }}
          variant="outlined"
          onClick={props.onClose}
        >
          Cancel
        </Button>
        <Button
          sx={{
            textTransform: "none",
            borderRadius: "7px",
            backgroundColor: "#3299FF",
          }}
          variant="contained"
          onClick={props.handleSave}
          disabled={!props.isEdit}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default AccessModalContent;
